import { useTranslations } from "next-intl";
import styles from "./epc-selector.module.css";
import { useEdittingStore } from "../context/useEdittingStore";

export default function EPCSelector() {
  const epc = useEdittingStore((state) => state.listing.epc);
  const error = useEdittingStore((state) => state.validationErrors.epc);
  const setField = useEdittingStore((state) => state.setField);
  const t = useTranslations("NewListing.EPC");
  return (
    <div className={styles.inputItem}>
      <h3 className={`${styles.fieldTitle} ${error && styles.error}`}>
        {t("title")}
      </h3>
      <p className={styles.fieldDescription}>{t("description")}</p>
      <div className={styles.selectorsButtonsWrapper}>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "A");
          }}
          className={`${styles.selectorButton} ${styles.A} ${
            epc === "A" && styles.isActive
          }`}
        >
          {t("a")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "B");
          }}
          className={`${styles.selectorButton} ${styles.B} ${
            epc === "B" && styles.isActive
          }`}
        >
          {t("b")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "C");
          }}
          className={`${styles.selectorButton} ${styles.C} ${
            epc === "C" && styles.isActive
          }`}
        >
          {t("c")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "D");
          }}
          className={`${styles.selectorButton} ${styles.D} ${
            epc === "D" && styles.isActive
          }`}
        >
          {t("d")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "E");
          }}
          className={`${styles.selectorButton} ${styles.E} ${
            epc === "E" && styles.isActive
          }`}
        >
          {t("e")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "F");
          }}
          className={`${styles.selectorButton} ${styles.F} ${
            epc === "F" && styles.isActive
          }`}
        >
          {t("f")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "G");
          }}
          className={`${styles.selectorButton} ${styles.G} ${
            epc === "G" && styles.isActive
          }`}
        >
          {t("g")}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setField("epc", "N/A");
          }}
          className={`${styles.selectorButton} ${
            epc === "N/A" && styles.isActive
          }`}
        >
          {t("n/a")}
        </button>
      </div>
    </div>
  );
}
